





























import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseChevron from '@shared/components/@atoms/BaseChevron/BaseChevron.vue';
import BaseScrollable from '@shared/components/@molecules/BaseScrollable/BaseScrollable.vue';
import { isClient } from '@shared/ui/utilities/helpers';
import Vue from 'vue';

interface TabConfigType {
  tabMaxContentHeight: any;
  tabShowText: string;
  tabHideText: string;
}

interface IBaseTab extends Vue {
  tabConfig: TabConfigType;
  isActive: boolean;
  desktopMin: number;
  _uid: number;
}

export default Vue.extend({
  name: 'BaseTab',
  components: {
    BaseChevron,
    BaseScrollable,
    BaseButton,
  },
  inject: ['tabConfig'],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: false,
      desktopMin: 1024,
    };
  },
  computed: {
    tabMaxContentHeight(this: IBaseTab): any {
      return this.tabConfig.tabMaxContentHeight;
    },
    tabShowText(this: IBaseTab): string {
      return this.tabConfig.tabShowText;
    },
    tabHideText(this: IBaseTab): string {
      return this.tabConfig.tabHideText;
    },
  },
  methods: {
    tabClick(this: IBaseTab) {
      if (!isClient) return;
      const width = Math.max(document.documentElement.clientWidth, window.innerWidth);
      if (this.isActive && width > this.desktopMin) return;
      this.$parent?.$emit('toggle', this._uid);
    },
  },
});
